<template>
  <nav>
    <v-card
      v-if="type == 'page'"
      height="100%"
      elevation="0"
      class="py-2 px-4"
      data-testid="design-card"
    >
      <div>
        <span class="text-subtitle-1">{{ $t('recentColorsTitle') }}</span>
        <div class="text-center" data-testid="recent-colors">
          <v-btn v-for="index in 6" :key="index" class="ma-1 pa-0 elevation-2" height="32" width="32" min-width="32"
            :color="recentColors[index - 1] ? recentColors[index - 1] : '#FFFFFF'"
            @click="$emit('changeBlockColor', recentColors[index - 1])" :class="{ 'disable-events': !recentColors[index - 1] }">
            <v-icon
              v-if="recentColors[index - 1] && (rgb2hex(block.background) == recentColors[index - 1] || rgb2hex(block.background) == recentColors[index - 1].toUpperCase())"
              color="greytext">
              mdi-check
            </v-icon>
          </v-btn>
        </div>
        <span class="text-subtitle-1">{{ $t('defaultColorsTitle') }}</span>
        <div class="text-center" data-testid="default-colors">
          <v-btn v-for="(color, index) in colorPalette" :key="index" class="ma-1 pa-0 elevation-2" height="32"
            width="32" min-width="32" :color="color" @click="$emit('changeBlockColor', color)">
            <v-icon
              v-if="rgb2hex(block.background) == color || rgb2hex(block.background) == color.toUpperCase()"
              color="greytext">
              mdi-check
            </v-icon>
          </v-btn>
        </div>
        <span class="text-subtitle-1">{{ $t('questionBackgroundColor') }}</span>
        <v-card-actions class="pb-2 pt-0 px-0">
          <v-card
            class="mx-auto"
            width="100%"
          >
            <v-expand-transition>
              <div v-show="showAdvancedColors" class="ma-2 text-center">
                <v-divider />
                <v-color-picker
                  class="ma-2"
                  :value="colorPickerBackgroundValue"
                  @input="setColorPickerColor"
                  data-testid="block-color"
                />
                <v-btn color="accent" elevation="0" class="rounded-xxl text-none px-4 mb-2 white--text" small
                  @click="setColor(colorPickerValue)">
                  {{ $t('applyColor') }}
                </v-btn>
              </div>
            </v-expand-transition>
          </v-card>
        </v-card-actions>
      </div>
    </v-card>
    <v-card
      v-else
      height="100%"
      elevation="0"
      class="py-2 px-4"
      data-testid="design-card"
    >
      <div v-if="question.type == 1 || question.type == 2 || question.type == 3" class="mb-5">
        <span class="text-subtitle-1">{{ $t('questionAllowedAnswers') }}</span>
        <v-card-actions class="py-2 px-0">
          <v-card
            class="mx-auto rounded-xxl"
            width="100%"
          >
            <v-select
              v-model="allowedAnswers"
              data-testid="allowed-answers-input" 
              solo 
              class="rounded-xxl select-items"
              hide-details="true"
              append-icon="mdi-chevron-down" 
              dense 
              :items="itemsAllowedAnswers" 
              item-text="name" 
              return-object 
              :menu-props="{ maxHeight: 350 }"   
              @change="setAllowedAnswers"
              :disabled="published"
            >
              <template v-slot:item="{item}">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <span v-html="item.name" />
              </template>
            </v-select>
          </v-card>
        </v-card-actions>
      </div>
      <div v-if="question.type == 6 || question.type == 7 || question.type == 8" class="mb-5">
        <span class="text-subtitle-1">{{ $t('questionRatingScale') }}</span>
        <v-card-actions class="py-2 px-0">
          <v-card
            class="mx-auto rounded-xxl"
            width="100%"
          >
            <v-select
              v-model="ratingScale"
              data-testid="rating-scale-input" 
              solo 
              class="rounded-xxl select-items"
              hide-details="true"
              append-icon="mdi-chevron-down" 
              dense 
              :items="itemsRatingScale" 
              :menu-props="{ maxHeight: 350 }"   
              @change="setRatingScale"
              :disabled="published"
            >
            </v-select>
          </v-card>
        </v-card-actions>
      </div>
      <div>
        <span class="text-subtitle-1">{{ $t('recentColorsTitle') }}</span>
        <div class="text-center mb-2" data-testid="recent-colors">
          <v-btn v-for="index in 6" :key="index" class="ma-1 pa-0 elevation-2" height="32" width="32" min-width="32"
            :color="recentColors[index - 1] ? recentColors[index - 1] : '#FFFFFF'"
            @click="$emit('changeBlockColor', recentColors[index - 1])" :class="{ 'disable-events': !recentColors[index - 1] }">
            <v-icon
              v-if="recentColors[index - 1] && (rgb2hex(question.bg_color) == recentColors[index - 1] || rgb2hex(question.bg_color) == recentColors[index - 1].toUpperCase())"
              color="greytext">
              mdi-check
            </v-icon>
          </v-btn>
        </div>
        <span class="text-subtitle-1">{{ $t('defaultColorsTitle') }}</span>
        <div class="text-center" data-testid="default-colors">
          <v-btn v-for="(color, index) in colorPalette" :key="index" class="ma-1 pa-0 elevation-2" height="32"
            width="32" min-width="32" :color="color" @click="$emit('changeBlockColor', color)">
            <v-icon
              v-if="rgb2hex(question.bg_color) == color || rgb2hex(question.bg_color) == color.toUpperCase()"
              color="greytext">
              mdi-check
            </v-icon>
          </v-btn>
        </div>
        <span class="text-subtitle-1">{{ $t('questionBackgroundColor') }}</span>
        <v-card-actions class="pb-2 pt-0 px-0">
          <v-card
            class="mx-auto"
            width="100%"
          >
            <v-expand-transition>
              <div v-show="showAdvancedColors" class="ma-2 text-center">
                <v-divider />
                <v-color-picker
                  class="ma-2"
                  :value="colorPickerBackgroundValue"
                  @input="setColorPickerColor"
                  data-testid="block-color"
                />
                <v-btn color="accent" elevation="0" class="rounded-xxl text-none px-4 mb-2 white--text" small
                  @click="setColor(colorPickerValue)">
                  {{ $t('applyColor') }}
                </v-btn>
              </div>
            </v-expand-transition>
          </v-card>
        </v-card-actions>
      </div>
    </v-card>
  </nav>
</template>
<script>
import i18n from '../plugins/i18n';

export default {
    components: { 
     },
    props:{
        question: {
          type: Object,
          default: () => {}
        },
        block: {
          type: Object,
          default: () => {}
        },
        published: {
          type: Boolean,
          default: false
        },
        colors: {
          type: Array,
          default: () => []
        },
        type: {
          type: String,
          default: ''
        }
        
    },

    data(){
      return{
        itemsAllowedAnswers: [
          {id: null, name: i18n.t('unlimited')},
          {id: '1', name: '1'},
          {id: '2', name: '2'},
          {id: '3', name: '3'},
        ],
        showAdvancedColors: true,
        allowedAnswers: {id: null, name: i18n.t('unlimited')},
        itemsRatingScale: [5,6,7,8,9,10],
        ratingScale: 10,
        recentColors: [],
        colorPickerValue: '#FFFFFF',
        spaceId: window.$cookies.get('space_id'),
        activityId: this.$route.params.id,
        colorPalette: ["#000000", "#545454", "#737373", "#A6A6A6", "#D9D9D9", "#FFFFFF"]
      }
    },    

    created(){
      if(this.type == 'survey'){
        if(this.question.type == 1 || this.question.type == 2 || this.question.type == 3){
          if(this.question.allowed_options != null){
            this.allowedAnswers = { id: JSON.stringify(this.question.allowed_options), name: JSON.stringify(this.question.allowed_options) }
          }else{
            this.allowedAnswers= {id: null, name: i18n.t('unlimited')}
          }
        }else if(this.question.type == 6 || this.question.type == 7 || this.question.type == 8){
          this.ratingScale = this.question.allowed_options
        }
      }
      this.recentColors = this.colors
    },
    computed:{
      colorPickerBackgroundValue(){
        if(this.type == 'page'){
          return this.block && this.block.background ? this.rgb2hex(this.block.background) : '#FFFFFF'
        }else{
          return this.question && this.question.bg_color ? this.rgb2hex(this.question.bg_color) : '#FFFFFF'
        }
      }
    },
    watch:{
        question(){
          if(this.question.type == 1 || this.question.type == 2 || this.question.type == 3){
            if(this.question.allowed_options != null){
              this.allowedAnswers = { id: JSON.stringify(this.question.allowed_options), name: JSON.stringify(this.question.allowed_options) }
            }else{
              this.allowedAnswers= {id: null, name: i18n.t('unlimited')}
            }
          }else if(this.question.type == 6 || this.question.type == 7 || this.question.type == 8){
            this.ratingScale = this.question.allowed_options
          }
        },
        colorPickerBackgroundValue(newColor) {
          this.setColorPickerColor(newColor);
        },
        colors(newVal){
          this.recentColors = newVal
        },
    },

    methods:{
        setColorPickerColor(value) {
          this.colorPickerValue = value
        },
        async setColor(value){
          this.$emit('changeBlockColor', value)
          if(value){
            this.recentColors = this.recentColors.filter((v) => v !== value);
            this.recentColors.unshift(value)
            if (this.recentColors.length > 6) {
              this.recentColors.splice(6, this.recentColors.length - 6);
            }
            this.$emit('changeRecentColors', this.recentColors)
          }
        },
        setAllowedAnswers(value){
            this.$emit('changeQuestionAllowedAnswers', value == null ? null : parseInt(value.id))
        },
        setRatingScale(value){
          this.$emit('changeQuestionRatingScale', value)
        },
        rgb2hex(orig) {
            if(orig != undefined){
                var a, isPercent,
                rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
                alpha = (rgb && rgb[4] || "").trim(),
                hex = rgb ? "#" +
                (rgb[1] | 1 << 8).toString(16).slice(1) +
                (rgb[2] | 1 << 8).toString(16).slice(1) +
                (rgb[3] | 1 << 8).toString(16).slice(1) : orig;
            if (alpha !== "") {
                isPercent = alpha.indexOf("%") > -1;
                a = parseFloat(alpha);
                if (!isPercent && a >= 0 && a <= 1) {
                a = Math.round(255 * a);
                } else if (isPercent && a >= 0 && a <= 100) {
                a = Math.round(255 * a / 100)
                } else {
                a = "";
                }
            }
            if (a) {
                hex += (a | 1 << 8).toString(16).slice(1);
            }
            return hex;
          }
       }
    }
}
</script>